// extracted by mini-css-extract-plugin
export default {"aba":"AddPerson_aba__ZE8Zz","header":"AddPerson_header__mRiQS","personalData":"AddPerson_personalData__3+QBt"};